<template>
  <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" :title='title' hide-footer>
    <div>
      <b-spinner v-if="loading" label="Carregando..." class="my-3 d-block mx-auto"></b-spinner>
      <div v-show="!loading">
        <b-card class="mb-3 p-2">
          <b-row>
            <b-col cols="12" sm="4">
              <b-card class="mb-2 p-2 d-flex align-items-center justify-content-center">
                <h5 class="mb-0 small-text">Pedido n°: {{ localPedido.numeroPedido }}</h5>
              </b-card>
            </b-col>
            <b-col cols="12" sm="4">
              <p class="mb-1 small-text"><strong>Data:</strong> {{ formatDate(localPedido.data) }}</p>
              <p class="mb-1 small-text"><strong>Solicitante:</strong> {{ localPedido.solicitante }}</p>
            </b-col>
            <b-col cols="12" sm="4" class="text-right">
              <p class="mb-1 small-text"><strong>Status do Pedido:</strong> {{ localPedido.status.descricao }}</p>
              <p class="mb-1 small-text"><strong>Unidade Administrativa:</strong> {{ localPedido.unidadeAdministrativa
                }}</p>
            </b-col>
          </b-row>
        </b-card>
        <!-- Justificativa do Pedido -->
        <b-card class="mb-3 p-2">
          <h5 class="mb-2 small-text">Justificativa do Pedido</h5>
          <b-form-group>
            <b-form-textarea v-model="localPedido.justificativa" rows="3" readonly></b-form-textarea>
          </b-form-group>
        </b-card>

        <!-- Aba de Navegação -->
        <b-card class="mb-3 p-2">
          <b-tabs>
            <b-tab title="Itens do Pedido" active>
              <!-- Tabela de Itens do Pedido -->
              <b-table :items="localPedido.itens" :fields="computedItemFields" responsive striped>
                <template #cell(detalhe)="data">
                  <b-button variant="link" @click="viewProduct(data.item.produtoCatalogo)"
                    class="d-flex align-items-center">
                    <b-icon icon="search" class="mr-1"></b-icon>
                  </b-button>
                </template>
                <template #cell(produto)="data">
                  <span class="text-nowrap ">{{ data.item.produtoCatalogo.descricao }}</span>
                </template>
                <template #cell(quantidade)="data">
                  <b-form-input v-model="data.item.quantidadePedida" type="number" :disabled="!isEmAnalise"
                    @input="updateValorEstimado(data.item)"></b-form-input>
                </template>
                <template #cell(processoCompra)="data">
                  <div class="d-flex">
                    <LgFinderPageProcessoCompra :produto='data.item.produtoCatalogo' class="parent-component"
                      :id="'finderpageProcessoCompra' + data.index" :value="data.item.processoCompra"
                      :prefix='updatedPrefix' :disabled="!isEmAnalise" @processCreated="reloadPedido" />
                  </div>
                </template>
                <template #cell(valorEstimado)="data">
                  {{ formatCurrency(data.item.quantidadePedida * data.item.valorUnitario) }}
                </template>
                <template #cell(aprovado)="data">
                  <div class="">
                    <b-form-checkbox v-model="data.item.aprovado" :disabled="!isEmAnalise"></b-form-checkbox>
                  </div>
                </template>
              </b-table>
            </b-tab>
            <b-tab title="Itens Movimentados">
              <div class="d-flex justify-content-end mb-2 mt-2">
                <LgFinderPageItemBemPermanente ref="finderItemBemPermanente" id="finder-item-bem-permanente"
                  @onselect="itemBemPermanenteSelect" mode='button' v-b-tooltip.hover title="Adicionar Item"
                  class="mx-2" :disabled="!isEmAnalise" />

                <b-button variant="success" style="height: 30px" pill size="sm" v-b-tooltip.hover
                  title="Gerar movimentação" @click="gerarMovimentacao" :disabled="!hasItensSemMovimentacao || loading">
                  <b-icon icon="play"></b-icon>
                </b-button>
              </div>
              <!-- Tabela de Itens Movimentados -->
              <b-table :items="localPedido.pedidoProdutoCatalogoItemBemPermanente" :fields="movimentadosFields"
                responsive bordered striped>
                <template #cell(localArmazenamento)="data">
                  <LgFinderPageLocalArmazenamento :id="'finderLocalArmazenamentoDetalhes' + data.index" label=' '
                    v-model='data.item.localArmazenamento' :prefix='title' @input="function(item){localArmazenamentoSelect(data.item, item)}"
                    :disabled="!isEmAnalise || !!data.item.solicitacaoMovimentacaoItemBemPermanente" />
                </template>
                <template #cell(remover)="data">
                  <b-button v-if="!data.item.solicitacaoMovimentacaoItemBemPermanente" variant="danger"
                    class="rounded-pill" @click="removerItem(data.index)" v-b-tooltip.hover title="Remover Item"
                    :disabled="!isEmAnalise">
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                </template>
              </b-table>
            </b-tab>
          </b-tabs>
        </b-card>

        <!-- Informações do Patrimônio -->
        <b-card class="mt-3 p-2">
          <b-card-header>
            <b-button v-b-toggle.collapse-patrimonio variant="link" class="small-text">
              Informações do Patrimônio
            </b-button>
            <b-icon icon="pencil" class="ml-2" @click="abrirModalObservacao"></b-icon>
          </b-card-header>
          <b-collapse id="collapse-patrimonio">
            <b-card-body>
              <b-form-group>
                <b-form-textarea v-model="observacoesTextarea" rows="3" readonly></b-form-textarea>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Botões de Ação -->
        <div class="d-flex justify-content-between mt-3">
          <div class="d-flex justify-content-center w-100">
            <b-button variant="primary" class="mx-2 rounded-pill" @click="iniciarAprovacao" :disabled="!isAguardando"
              v-b-tooltip.hover title="Iniciar Aprovação">
              <b-icon icon="play"></b-icon>
            </b-button>
            <b-button variant="success" class="mx-2 rounded-pill" @click="salvar" :disabled="!isEmAnalise"
              v-b-tooltip.hover title="Salvar">
              <b-icon icon="check"></b-icon>
            </b-button>
            <b-button variant="danger" class="mx-2 rounded-pill" @click="cancelar" v-b-tooltip.hover title="Cancelar">
              <b-icon icon="x-circle"></b-icon>
            </b-button>
          </div>
          <div>
            <b-button variant="dark" class="mx-2 rounded-pill" @click="finalizar" :disabled="!isEmAnalise"
              v-b-tooltip.hover title="Finalizar Pedido">
              <b-icon icon="check-circle"></b-icon>
            </b-button>
          </div>
        </div>
      </div>
      <DescricaoDetalhadaProduto v-if="showModalDescricaoDetalhada" :mostrarDetalhes='false' @fecharModal='fecharModal'
        :id="idproduto" />
    </div>
    <b-modal v-model="modalObservacaoAberto" title="Editar Observação" hide-footer>
      <b-form-group>
        <b-form-textarea v-model="observacaoTemp" rows="3"></b-form-textarea>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" class='rounded-pill mr-2' @click="cancelar"><b-icon
            icon="x-circle"></b-icon></b-button>
        <b-button variant="success" class='rounded-pill' @click="confirmarObservacao"
          :disabled="!observacaoTemp"><b-icon icon="check"></b-icon></b-button>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import LgFinderPageItemBemPermanente from "@/components/Finders/LgFinderPageItemBemPermanente.vue"
import API from "@/core/api"
import StatusEnum from "@/core/utils/StatusEnum.js"
import LgFinderPageLocalArmazenamento from "../../../components/Finders/LgFinderPageLocalArmazenamento.vue"
import LgFinderPageProcessoCompra from "../../../components/Finders/LgFinderPageProcessoCompra.vue"
import DescricaoDetalhadaProduto from "./DescricaoDetalhadaProduto.vue"

export default {
  components: {
    LgFinderPageItemBemPermanente,
    LgFinderPageProcessoCompra,
    DescricaoDetalhadaProduto,
    LgFinderPageLocalArmazenamento
  },
  props: {
    idPedido: {
      type: Number,
      required: true
    },
    prefix: {
      type: Array,
      default: () => []
    }
  },
  created() {
    const brand = JSON.parse(localStorage.getItem("context"))
    this.departamento = brand.departamento
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, 'Detalhamento de Pedido']
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
    isAguardando() {
      return this.localPedido.status.id === StatusEnum.PEDIDO_PRODUTO_CATALOGO_AGUARDANDO.value
    },
    isEmAnalise() {
      return this.localPedido.status.id === StatusEnum.PEDIDO_PRODUTO_CATALOGO_ANALISE.value
    },
    hasItensSemMovimentacao() {
      return this.localPedido.pedidoProdutoCatalogoItemBemPermanente && this.localPedido.pedidoProdutoCatalogoItemBemPermanente.some(item => !item.solicitacaoMovimentacaoItemBemPermanente)
    },
    computedItemFields() {
      const fields = [
        { key: 'detalhe', label: '', tdClass: 'w-1' },
        { key: 'produto', label: 'Produto' },
        // { key: 'produtoCatalogo.apelido', label: 'Produto' },
        { key: 'quantidade', label: 'Quantidade' },
        { key: 'processoCompra', label: 'Processo de Compra' },
        { key: 'valorEstimado', label: 'Valor Estimado' }
      ]
      if (this.isEmAnalise) {
        fields.push({ key: 'aprovado', label: 'Aprovado', thClass: 'text-right', tdClass: 'text-right' })
      }
      return fields
    }
  },
  data() {
    return {
      modalAberto: true,
      showModalDescricaoDetalhada: false,
      idproduto: null,
      loading: false,
      movimentadosFields: [
        { key: 'itemBemPermanente.numTombamento', label: 'Tombamento' },
        { key: 'itemBemPermanente.s_numTombAntigo', label: 'Tombamento Samp' },
        { key: 'itemBemPermanente.federalSupply', label: 'Federal Supply' },
        { key: 'itemBemPermanente.itemRegEntrada.produto.descricaoResumida', label: 'Produto' },
        { key: 'localArmazenamento', label: 'Localização' },
        { key: 'solicitacaoMovimentacaoItemBemPermanente.id', label: 'Nº Solicitação' },
        { key: 'remover', label: '' }
      ],
      localPedido: {
        numeroPedido: '',
        data: '',
        solicitante: '',
        status: {
          id: null,
          descricao: ''
        },
        unidadeAdministrativa: '',
        justificativa: '',
        itens: [],
        pedidoProdutoCatalogoItemBemPermanente: [],
        observacoes: []
      },
      modalObservacaoAberto: false,
      observacaoTemp: '',
      observacoesTextarea: ''
    }
  },
  async beforeMount() {
    await this.reloadPedido()
  },
  methods: {
      fecharModal() {
      this.idproduto = null
      this.showModalDescricaoDetalhada = false
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
    },
    viewProduct(produto) {
      this.idproduto = produto.id
      this.showModalDescricaoDetalhada = true
    },
    iniciarAprovacao() {
      API.put(`/api/pedidosprodutocatalogo/${this.localPedido.id}/iniciar-aprovacao`)
        .then(() => {
          this.localPedido.status.id = StatusEnum.PEDIDO_PRODUTO_CATALOGO_ANALISE.value
          this.localPedido.status.descricao = 'Em análise'
          this.$emit('voltar')
        })
        .catch(error => {
          console.error('Erro ao iniciar a aprovação:', error)
        })
    },
    async salvar() {
      await API.put(`/api/pedidosprodutocatalogo/${this.localPedido.id}/salvar`, this.localPedido, {
        params: { finalizar: false }
      })
        .then(() => {
          this.$bvToast.toast('Pedido salvo com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
          this.$emit('voltar')
        })
        .catch(error => {
          this.$bvToast.toast('Erro ao salvar o pedido.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
          console.error('Erro ao salvar o pedido:', error)
        })
    },
    async finalizar() {
      await API.put(`/api/pedidosprodutocatalogo/${this.localPedido.id}/salvar`, this.localPedido, {
        params: { finalizar: true }
      })
        .then(() => {
          this.$bvToast.toast('Pedido finalizado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
          this.cancelar();
        })
        .catch(error => {
          this.$bvToast.toast('Erro ao finalizar o pedido.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
          console.error('Erro ao finalizar o pedido:', error)
        })
    },
    cancelar() {
      this.$emit('close')
    },
    async reloadPedido() {
      this.loading = true
      await API.get(`/api/pedidosprodutocatalogo/${this.idPedido}`)
        .then(response => {
          this.localPedido = {
            ...response.data,
            pedidoProdutoCatalogoItemBemPermanente: response.data.pedidoProdutoCatalogoItemBemPermanente || [],
            observacoes: response.data.observacoes || []
          }
          this.updateObservacoesTextarea()
        })
        .catch(error => {
          console.error('Erro ao recarregar o pedido:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateObservacoesTextarea() {
      this.observacoesTextarea = this.localPedido.observacoes
        .map(obs => `${obs.descricao} (Em: ${this.formatDate(obs.dataCriacao)})`)
        .join('\n')
    },
    adicionarItem() {
      this.$refs.finderItemBemPermanente.show()
    },
    async gerarMovimentacao() {
      try {
        this.loading = true
        const itensSemSolicitacao = this.localPedido.pedidoProdutoCatalogoItemBemPermanente
          .filter(item => !item.solicitacaoMovimentacaoItemBemPermanente)

        const movimentacaoDto = {
          pedidoProdutoCatalogo: this.localPedido,
          itens: itensSemSolicitacao,
          movimentacaoDireta: false,
          devolucaoAoDeposito: true,
          departamentoDestino: null,
          descricao: null,
        }

        const response = await API.post('/api/pedidosprodutocatalogo/create-movimentacao', movimentacaoDto)


        this.localPedido.pedidoProdutoCatalogoItemBemPermanente.forEach(item => {
          if (!item.solicitacaoMovimentacaoItemBemPermanente) {
            item.solicitacaoMovimentacaoItemBemPermanente = { id: response.data }
          }
        })
        this.$bvToast.toast('Movimentação gerada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        this.$bvToast.toast('Erro ao gerar movimentação.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        console.error('Erro ao gerar movimentação:', error)
      } finally {
        this.loading = false
      }
    },
    removerItem(index) {
      this.localPedido.pedidoProdutoCatalogoItemBemPermanente.splice(index, 1)
      this.salvar()
    },
    itemBemPermanenteSelect(item) {
      const novoItem = {
        pedidoProdutoCatalogoId: this.localPedido.id,
        itemBemPermanenteId: item.id,
        itemBemPermanente: item,
        solicitacaoMovimentacaoItemBemPermanente: null,
        localArmazenamento: null
      }
      this.localPedido.pedidoProdutoCatalogoItemBemPermanente.push(novoItem)
      this.salvar()
    },
    localArmazenamentoSelect(item, local) {
      item.localArmazenamento = local;
    },
    updateValorEstimado(item) {
      item.valorEstimado = item.quantidadePedida * item.valorUnitario
    },
    abrirModalObservacao() {
      this.modalObservacaoAberto = true
    },
    confirmarObservacao() {
      if (!this.observacaoTemp) {
        this.$bvToast.toast('A observação não pode estar vazia.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }
      this.loading = true
      this.modalObservacaoAberto = false
      API.post(`/api/pedidosprodutocatalogo/${this.localPedido.id}/adicionar-observacao`, { observacao: this.observacaoTemp })
        .then(response => {
          const novaObservacao = response.data
          this.localPedido.observacoes.push(novaObservacao)
          this.updateObservacoesTextarea()
          this.observacaoTemp = ''
          this.$bvToast.toast('Observação adicionada com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
        })
        .catch(error => {
          this.$bvToast.toast('Erro ao adicionar observação.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
          console.error('Erro ao adicionar observação:', error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.parent-component ::v-deep .form-group {
  margin-bottom: 0 !important;
}

.ml-2 {
  margin-left: 0.5rem;
}
</style>